exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.picture-edit[data-v-2ae09b2c] {\n  position: absolute;\n  top: 79px;\n  right: calc(50% - 70px);\n  width: 32px;\n  height: 32px;\n  background-image: url('/img/pencel.png');\n  background-size: 20px;\n  background-position: center center;\n  background-repeat: no-repeat;\n  background-color: #ffffff;\n}\n", ""]);

// exports
